module.exports = __webpack_public_path__ + "static/media/drunk_robot.e0ef6536.png";